angular.module('memberPortal').controller('StylesCtrl', ["$scope", "$stateParams", "DataService", "styles", function($scope, $stateParams, DataService, styles) {
  var domain;
  $scope.data = DataService;
  domain = $scope.data.domain;
  $scope.hash = $stateParams.m;
  return $scope.styles = styles;
}]);
